const DEV_PRODUCTS = [
  {
    id: 1739426529337,
  },
  {
    id: 1784403230777,
  },
  {
    id: 1784403263545,
  },
]

export default {
  state: {
    recommendedProducts: [],
    hasRecommendedProducts: false,
  },
  getters: {
    recommendedProducts: state => state.recommendedProducts,
    hasRecommendedProducts: state => 0 < state.recommendedProducts.length,
  },
  mutations: {
    setRecommendedProducts(state, { products }) {
      state.recommendedProducts = products
      state.hasRecommendedProducts = true
    },
  },
  actions: {
    fetchRecommendedProducts({ commit }) {
      if (NODE_ENV != 'production') {
        commit('setRecommendedProducts', {
          products: DEV_PRODUCTS,
        })
        return
      }
      return new Promise((resolve, reject) => {
        window.ScarabQueue.push([
          'recommend',
          {
            logic: 'RELATED',
            containerId: 'related-products__wrapper',
            limit: '3',
            success: SC => {
              commit('setRecommendedProducts', {
                products: SC.page.products.map(p => ({
                  id: p.id,
                })),
              })
              resolve()
            },
          },
        ])
      })
    },
  },
}
